/*
 * @Author: zhengxiaowen
 * @Date: 2018-10-10 21:43:20
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2018-10-24 14:35:54
 */
import platform from '@/config/platform'

let host = platform.host

let api = {
    // 正在办理的任务查询
    bpmTaskService_findActiveTasks: `${host}/bpmServer/bpmTaskService/findActiveTasks`,

    // 流程沟通/催办
    bpmCommunicateService_save: `${host}/bpmServer/bpmCommunicateService/save`,
}

export default api



// WEBPACK FOOTER //
// ./src/common/config/apiCommon.js